import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "./App.css";
import { CartProvider } from "./context/CartContext";
import { Navbar } from "./components/Navbar";
import { CartDrawer } from "./components/CartDrawer";
import { ComplianceGate } from "./components/ComplianceGate";
import { SpinWin } from "./components/SpinWin";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import BundleBuilder from "./pages/BundleBuilder";
import BundleDetail from "./pages/BundleDetail";
import Rewards from "./pages/Rewards";
import Policies from "./pages/Policies";
import ProductDetail from "./pages/ProductDetail";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import CryptoReturn from "./pages/CryptoReturn";
import BankTransfer from "./pages/BankTransfer";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function App() {
  return (
    <div className="App grain min-h-screen bg-ink-900">
      <BrowserRouter>
        <CartProvider>
          <SmoothScroll />
          <ScrollManager />
          <ComplianceGate />
          <SpinWin />
          <Navbar />
          <CartDrawer />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/build" element={<BundleBuilder />} />
              <Route path="/bundle/:slug" element={<BundleDetail />} />
              <Route path="/rewards" element={<Rewards />} />
              <Route path="/policies" element={<Policies />} />
              <Route path="/product/:handle" element={<ProductDetail />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/payment/crypto-return" element={<CryptoReturn />} />
              <Route path="/checkout/bank-transfer" element={<BankTransfer />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#121214",
                border: "1px solid #27272A",
                color: "#fff",
                borderRadius: 0,
                fontFamily: "IBM Plex Mono, monospace",
                fontSize: "13px",
              },
            }}
          />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
